import './style.scss'

function InstructorProfileThingsToKnow() {
	return (
		<div className='section-content instructor-profile-things-to-know-section'>
			<div className='instructor-profile-things-to-know-title'>
				Things to know
			</div>
			<div className='instructor-profile-things-to-know-list-wrap'>
				<div className='instructor-profile-things-to-know-list-item'>
					<div className='instructor-profile-things-to-know-list-item-title'>
						Session Guidelines
					</div>
					<div className='instructor-profile-things-to-know-list-item-content'>
						After you submit your analysis request, your instructor will review it, complete the analysis, and send feedback within 24 hours. All interactions and results will be available through your customer dashboard on the site.
					</div>
					{/* <div className='instructor-profile-things-to-know-list-item-more'>
						Show more &gt;
					</div> */}
				</div>
				<div className='instructor-profile-things-to-know-list-item instructor-profile-things-to-know-list-item-middle'>
					<div className='instructor-profile-things-to-know-list-item-title'>
						Safety & Conduct Guidelines
					</div>
					<div className='instructor-profile-things-to-know-list-item-content'>
					For your safety, videos uploaded to the site cannot be removed, and sharing personal contact details is not allowed. When skiing or snowboarding, always follow mountain guidelines—wear a helmet, stay in bounds, and be aware of your surroundings
					</div>
					{/* <div className='instructor-profile-things-to-know-list-item-more'>
						Show more &gt;
					</div> */}
				</div>
				<div className='instructor-profile-things-to-know-list-item'>
					<div className='instructor-profile-things-to-know-list-item-title'>
						Refund Policy
					</div>
					<div className='instructor-profile-things-to-know-list-item-content'>
						If your instructor does not respond to your analysis request within 24 hours, you will be eligible for a full refund. Please review the full refund policy for additional details.
					</div>
					{/* <div className='instructor-profile-things-to-know-list-item-more'>
						Show more &gt;
					</div> */}
				</div>
			</div>
		</div>
	)
}

export default InstructorProfileThingsToKnow
